/**
 * Shop Analytics Module
 *
 * Tracks GA4 e-commerce events on listing pages:
 * - view_item_list: when product cards are visible in viewport
 * - select_item: when a product card is clicked
 */

function getListName() {
  const heading = document.querySelector(".shop-collection h1, .shop-index__section-title");
  return heading ? heading.textContent.trim() : "Shop";
}

function cardToItem(card, index) {
  const handle = card.dataset.productHandle;
  const titleEl = card.querySelector(".shop-card__title");
  const priceEl = card.querySelector(".shop-card__price");
  const priceText = priceEl ? priceEl.textContent.replace(/[^\d.,]/g, "").replace(/\./g, "").replace(",", ".") : "0";

  return {
    item_id: handle,
    item_name: titleEl ? titleEl.textContent.trim() : handle,
    item_brand: "VANYX",
    item_list_name: getListName(),
    index: index,
    price: parseFloat(priceText) || 0,
    currency: "EUR",
  };
}

function initViewItemList() {
  const cards = document.querySelectorAll("[data-product-handle]");
  if (!cards.length || typeof window.gtag !== "function") {
    return;
  }

  const listName = getListName();
  const observed = new Set();

  const observer = new IntersectionObserver((entries) => {
    const visibleItems = [];

    for (const entry of entries) {
      if (entry.isIntersecting && !observed.has(entry.target)) {
        observed.add(entry.target);
        const index = Array.from(cards).indexOf(entry.target);
        visibleItems.push(cardToItem(entry.target, index));
        observer.unobserve(entry.target);
      }
    }

    if (visibleItems.length > 0) {
      window.gtag("event", "view_item_list", {
        item_list_name: listName,
        items: visibleItems,
      });
    }
  }, { threshold: 0.5 });

  cards.forEach((card) => observer.observe(card));
}

function initSelectItem() {
  const cards = document.querySelectorAll("[data-product-handle]");
  if (!cards.length || typeof window.gtag !== "function") {
    return;
  }

  cards.forEach((card, index) => {
    card.addEventListener("click", () => {
      window.gtag("event", "select_item", {
        item_list_name: getListName(),
        items: [cardToItem(card, index)],
      });
    });
  });
}

export function init() {
  initViewItemList();
  initSelectItem();
}
